export const privateMessageEvent = 'fQ3hgiPZxUli5Y/ObWQf2538/QuWm2M1ahpeY8CHTWY=';
